// This was generated during the migration to @kiwicom/eslint-config
// PLEASE REMOVE THE GLOBAL ESLINT DISABLE BELOW
// AND FIX ERRORS ACCORDINGLY.
/* eslint-disable no-restricted-imports */
// FIXME: remove this disable directive and fix the ESLint error(s)

// @ts-expect-error: Flow to TS migration.
import fp from "lodash/fp"

const throttleNotFixed = fp.throttle.convert({ fixed: false })

// @ts-expect-error: Flow to TS migration.
export const throttleTrailing = fp.curry((wait, fn) =>
  throttleNotFixed(wait)(fn, { leading: false, trailing: true }),
)

// @ts-expect-error: Flow to TS migration.
export const throttleLeading = fp.curry((wait, fn) =>
  throttleNotFixed(wait)(fn, { leading: true, trailing: false }),
)
